module.exports = __webpack_public_path__ + "static/media/11 Sharma and thakut.9acbafd8.pdf";